<template>
<Modal 
    :value="value" 
    @on-visible-change="val=>$emit('input',val)"  
    title="裁剪图片"
    width="840"
    :mask-closable="false"
>
    <div style="height:418px">
        <vueCropper
            ref="cropper"
            :img="item.base"
            :autoCrop="cropper.autoCrop"
            :autoCropWidth="cropper.autoCropWidth"
            :autoCropHeight="cropper.autoCropHeight"
            :fixed="cropper.fixed"
            :fixedNumber="cropper.fixedNumber"
            :fixedBox="cropper.fixedBox"
            :centerBox="cropper.centerBox"
            :canMove="cropper.canMove"
            :canScale="cropper.canScale"
        />
    </div>
    <div slot="footer">
        <Button type="primary" size="large" long @click="onSave">保存</Button>
    </div>
</Modal>
</template>
<script>
import {VueCropper} from 'vue-cropper';
import Compress from '@/server/compress.js';
export default {
    name: 'cropper',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    components: { VueCropper },
    data() {
        return {
            cropper: {
                img: 'http://ofyaji162.bkt.clouddn.com/bg1.jpg',
                autoCrop: true,
                autoCropWidth: 320,
                autoCropHeight: 200,
                fixed: true,
                fixedNumber: [32, 20],
                fixedBox: false,
                centerBox: true,
                canMove: false,
                canScale: false,
            },
        };
    },
    methods: {
        /**
         * @desc 保存截图
         */
        onSave() {
            if (this.$refs.cropper.cropW < 320) {
                this.$Message.error({ content: '裁剪尺寸不能少于320x200', duration: 2 });
                return;
            }
            this.$refs.cropper.getCropData(data => {
                const img = new Image();
                img.src = data;
                img.onload = async () => {
                    const formData = new FormData();
                    formData.append('img', this.dataURLtoFile(Compress(img), `${this.item.name}.jpg`));
                    const res = await this.$axios.post(this.$port.manager.uploadImg, formData);
                    this.$emit('input', false);
                    this.$set(this.item, 'imgUrl', res.data.urls[0]);
                };
            });
        },
        /**
         * @desc dataURL转File
         * @param {Dataurl} dataurl base64数据
         * @param {String} filename 文件名
         */
        dataURLtoFile(dataurl, filename) {
            //将base64转换为文件
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
    },
};
</script>
<style>
.vue-cropper {
    background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NewPromotion/cropper.vue